import { Students } from "../students"

export const WorkForceEmployees = ({pageSwap, goToScreen}) => {
    return(
        <Students titleScreen={"Werknemers"} customerStage={5} pageSwap={pageSwap} goToScreen={goToScreen}/>
    )
}